import { IApplicationState } from '../../types/redux';

export const selectProgramsVersion = (state: IApplicationState) => state.calculator.programsVersion;
